import styled from 'styled-components';

import {colors, font} from '@/app/styles/theme';

export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10px;
`;

export const Description = styled.div`
    color: ${colors.textPrimary};
    text-align: center;
    font-family: ${font.family.primary};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
`;

export const DescriptionBold = styled(Description)`
    font-weight: 700;
    margin-bottom: 24px;
`;
